import React, { Component } from "react";
import { Link } from "react-router-dom";
import Content from "../../../content/Content";
import styles from "../../../assets/css/modules/shared/navigation/tabNavWithHeader.css";
import SideSwipe from "../containers/SideSwipe";
import SlideyMenu from "../containers/SlideyMenu";
import slideyStyles from "../../../assets/css/modules/containers/slidey-menu.css";

export default class TabNavWithHeader extends Component {
  state = {};

  clearHighlight = (e) => {
    this.setState({ highlightedMenu: undefined });
  };

  render() {
    return (
      <div
        className={
          this.props.backgroundColourClass +
          " " +
          styles.tabNavWithHeader +
          " tabNavWithHeader " +
          (this.props.applyTabNavWithImageStyles
            ? styles.extraTabNavWithImageStyles
            : "")
        }
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>
              {this.props.heading!==undefined ? <Content name={this.props.heading} /> : ""}
              </h1>
              {this.props.links ? (
                <div role="navigation" aria-label={this.props.label}>
                  <SideSwipe>
                    <SlideyMenu
                      strokeStyle={slideyStyles.navStroke2}
                      selectedMenu={"_" + this.props.currentLinkIndex}
                      highlightedMenu={this.state.highlightedMenu}
                    >
                      <ul
                        onMouseLeave={this.clearHighlight}
                        onBlur={this.clearHighlight}
                      >
                        {this.props.links.map((link, key) => {
                          return (
                            <li key={key}>
                              <Content names={[link.Link, link.Text]}>
                                {(link, text) => (
                                  <Link
                                    to={link}
                                    data-menu={"_" + key}
                                    className={
                                      key === (this.props.currentLinkIndex || 0)
                                        ? styles.active
                                        : ""
                                    }
                                    onMouseOver={() =>
                                      this.setState({
                                        highlightedMenu: "_" + key
                                      })
                                    }
                                    onFocus={() =>
                                      this.setState({
                                        highlightedMenu: "_" + key
                                      })
                                    }
                                  >
                                    {text}
                                  </Link>
                                )}
                              </Content>
                            </li>
                          );
                        })}
                      </ul>
                    </SlideyMenu>
                  </SideSwipe>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
